import React from 'react';
import PropTypes from 'prop-types';
import { Plus } from '../../../../assets/images/index';

import { StyledViewMore, StyledPlus } from './styleButtonShowMore';

const ButtonShowMore = ({ className, color, text }) => (
  <StyledViewMore className={className}>
    <StyledPlus color={color} svg={Plus} />
    {text}
  </StyledViewMore>
);

ButtonShowMore.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  text: PropTypes.string
};

ButtonShowMore.defaultProps = {
  color: 'primary',
  text: 'Ver todas'
};

export default ButtonShowMore;
